<template>
  <div class="mobile-container">
    <div class="mobile-header">
      <div class="mobile-header-left">
        <div class="mobile-column">
          <h1 class="mobile-title">
            <b-icon-person-plus class="title-icon"/>
            Cadastro de Cliente
          </h1>
          <span class="required-hint">* Campos obrigatórios</span>
        </div>
        </div>
      <button
        v-if="onClose"
        class="btn-close-modern"
        @click="onClose"
      >
        <i class="fas fa-times"></i>
        Fechar
      </button>
    </div>
    
    <div class="mobile-tabs">
      <button
        v-for="item in tabs"
        :key="item.text"
        class="mobile-tab"
        :class="{
          active: selectedLabel === item.text
        }"
        @click="storeLabelName(item.text)"
      >
        {{ item.text }}
      </button>
    </div>
    <div v-if="selectedLabel === 'Informações Gerais'" class="tab-content">
      <input hidden v-model="dataCostumer.id">
      
      <div class="compact-section">
        <div class="section-header">
          <b-icon-person-fill class="section-icon"/>
          <span>Dados Principais</span>
        </div>
        <div class="form-grid">
          <div class="form-group full-width">
            <input
              :class="`form-input ${invalidFields?.nome && 'error'}`"
              v-model="dataCostumer.nome"
              @blur="clearInvalidFields('nome')"
              @input="clearInvalidFields('nome')"
              placeholder=" "
            />
            <label class="form-label">
              Nome <span class="required">*</span>
            </label>
          </div>
          
          <div class="form-group">
            <input
              :class="`form-input ${invalidFields?.cpfCnpj && 'error'}`"
              v-model="dataCostumer.cpfCnpj"
              v-mask="maskCpfCnpj(dataCostumer.cpfCnpj)"
              maxlength="18"
              @input="checkInputLength(true)"
              @blur="clearInvalidFields('cpfCnpj')"
              placeholder=" "
            />
            <label class="form-label">
              CPF/CNPJ <span class="required">*</span>
            </label>
            <button
              v-if="isInputLengthValid"
              class="action-btn"
              @click="fetchCnpj(dataCostumer.cpfCnpj)"
            >
              <b-spinner v-if="spinGeneralCnpj" small/>
              <span v-else>🔍</span>
            </button>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataCostumer.ie"
              placeholder=" "
            />
            <label class="form-label">IE</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataCostumer.rg"
              placeholder=" "
            />
            <label class="form-label">RG</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-geo-alt-fill class="section-icon"/>
          <span>Endereço</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              :class="`form-input ${invalidFields?.cep && 'error'}`"
              v-model="dataCostumer.cep"
              @blur="clearInvalidFields('cep')"
              @input="clearInvalidFields('cep')"
              v-mask="maskCep"
              placeholder=" "
            />
            <label class="form-label">CEP</label>
            <button
              class="action-btn"
              @click="fetchCep(dataCostumer.cep)"
            >
              <b-spinner v-if="spinGeneral" small/>
              <span v-else>🔍</span>
            </button>
          </div>
          
          <div class="form-group two-thirds">
            <input
              class="form-input"
              v-model="dataCostumer.endereco"
              placeholder=" "
            />
            <label class="form-label">Endereço</label>
          </div>
          
          <div class="form-group one-third">
            <input
              class="form-input"
              v-model="dataCostumer.numero"
              placeholder=" "
            />
            <label class="form-label">Número</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataCostumer.bairro"
              placeholder=" "
            />
            <label class="form-label">Bairro</label>
          </div>
          
          <div class="form-group">
            <input
              :class="`form-input ${invalidFields?.cidade && 'error'}`"
              v-model="dataCostumer.cidade"
              @blur="clearInvalidFields('cidade')"
              @input="clearInvalidFields('cidade')"
              placeholder=" "
            />
            <label class="form-label">Cidade</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              :class="`form-select ${invalidFields?.uf && 'error'}`"
              value-field="value"
              text-field="text"
              :options="ufs"
              v-model="dataCostumer.uf"
              @blur.native="clearInvalidFields('uf')"
            />
            <label class="select-label">UF</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataCostumer.complemento"
              placeholder=" "
            />
            <label class="form-label">Complemento</label>
          </div>
          <!-- <div class="form-group">
            <input
              class="form-input"
              v-model="dataCostumer.latitude"
              placeholder=" "
            />
            <label class="form-label">Latitude : (UTMN)</label>
          </div>

          <div class="form-group">
            <input
              class="form-input"
              v-model="dataCostumer.longitude"
              placeholder=" "
            />
            <label class="form-label">Longitude : (UTME)</label>
          </div> -->
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-telephone-fill class="section-icon"/>
          <span>Contato</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              class="form-input"
              v-mask="maskTelefone"
              v-model="dataCostumer.telefone"
              placeholder=" "
            />
            <label class="form-label">Telefone</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataCostumer.celular"
              v-mask="maskCelular"
              placeholder=" "
            />
            <label class="form-label">WhatsApp</label>
            <div class="whatsapp-icon">
              <img class="whatsapp-img" :src="whatsapp"/>
            </div>
          </div>
          
          <div class="form-group full-width">
            <input
              class="form-input"
              v-model="dataCostumer.email"
              placeholder=" "
            />
            <label class="form-label">Email</label>
          </div>
        </div>
      </div>

      <div class="compact-section">
        <div class="section-header">
          <b-icon-info-circle class="section-icon"/>
          <span>Outras Informações</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              type="date"
              class="form-input"
              v-model="dataCostumer.dataNascimento"
            />
            <label class="form-label">Nascimento</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="consumidorFinal"
              v-model="dataCostumer.consumidor_final"
            />
            <label class="select-label">Tipo</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="contribuinte"
              v-model="dataCostumer.contribuinte"
            />
            <label class="select-label">Contribuinte</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="status"
              v-model="dataCostumer.status"
              :disabled="!dataCostumer.id"
            />
            <label class="select-label">Status</label>
          </div>
          
          <div class="form-group full-width">
            <textarea
              class="form-textarea"
              v-model="dataCostumer.observacao"
              placeholder="Observações"
            />
          </div>
        </div>
      </div>

      <div class="action-buttons-fixed">
        <button class="btn-secondary" @click="handleNewCustomer">
          <b-icon-arrow-clockwise/>
          Novo
        </button>
        <button class="btn-primary" @click="saveOrUpdateCustomer">
          <b-icon-person-check/>
          {{ dataCostumer.id ? "Atualizar" : "Salvar" }}
        </button>
      </div>
    </div>

    <div v-show="selectedLabel === 'Propriedades'" class="tab-content">
      <div class="compact-section">
        <div class="section-header">
          <b-icon-building class="section-icon"/>
          <span>Nova Propriedade</span>
        </div>
        <div class="form-grid">
          <div class="form-group full-width">
            <input
              :class="`form-input ${invalidFieldsProperty?.nome && 'error'}`"
              v-model="property.nome"
              @blur="clearInvalidFields('nome', 'invalidFieldsProperty')"
              @input="clearInvalidFields('nome', 'invalidFieldsProperty')"
              placeholder=" "
            />
            <label class="form-label">Nome da Propriedade</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.cpfCnpj"
              v-mask="maskCpfCnpj(property.cpfCnpj)"
              @input="checkInputLength"
              placeholder=" "
            />
            <label class="form-label">CPF/CNPJ</label>
            <button
              v-if="isInputPropertyLengthValid"
              class="action-btn"
              @click="fetchCnpj(property.cpfCnpj, 'property')"
            >
              <b-spinner v-if="spinGeneralCnpj" small/>
              <span v-else>🔍</span>
            </button>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.ipr"
              placeholder=" "
            />
            <label class="form-label">I.PR</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.area"
              placeholder=" "
            />
            <label class="form-label">Área (M²)</label>
          </div>
          
          <div class="form-group">
            <input
              :class="`form-input ${invalidFieldsProperty?.cep && 'error'}`"
              v-model="property.cep"
              v-mask="maskCep"
              @blur="clearInvalidFields('cep', 'invalidFieldsProperty')"
              @input="clearInvalidFields('cep', 'invalidFieldsProperty')"
              placeholder=" "
            />
            <label class="form-label">CEP</label>
            <button
              class="action-btn"
              @click="fetchCep(property.cep, 'property')"
            >
              <b-spinner v-if="spinGeneral" small/>
              <span v-else>🔍</span>
            </button>
          </div>
          
          <div class="form-group two-thirds">
            <input
              class="form-input"
              v-model="property.endereco"
              placeholder=" "
            />
            <label class="form-label">Endereço</label>
          </div>
          
          <div class="form-group one-third">
            <input
              class="form-input"
              v-model="property.numero"
              placeholder=" "
            />
            <label class="form-label">Número</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.bairro"
              placeholder=" "
            />
            <label class="form-label">Bairro</label>
          </div>
          
          <div class="form-group">
            <input
              :class="`form-input ${invalidFieldsProperty?.cidade && 'error'}`"
              v-model="property.cidade"
              @blur="clearInvalidFields('cidade', 'invalidFieldsProperty')"
              @input="clearInvalidFields('cidade', 'invalidFieldsProperty')"
              placeholder=" "
            />
            <label class="form-label">Cidade</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              :class="`form-select ${invalidFieldsProperty?.uf && 'error'}`"
              value-field="value"
              text-field="text"
              :options="ufs"
              v-model="property.uf"
              @blur.native="clearInvalidFields('uf', 'invalidFieldsProperty')"
            />
            <label class="select-label">UF</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.complemento"
              placeholder=" "
            />
            <label class="form-label">Complemento</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.latitude"
              placeholder=" "
            />
            <label class="form-label">Latitude</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.longitude"
              placeholder=" "
            />
            <label class="form-label">Longitude</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-mask="maskTelefone"
              v-model="property.telefone"
              placeholder=" "
            />
            <label class="form-label">Telefone</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="property.celular"
              v-mask="maskCelular"
              placeholder=" "
            />
            <label class="form-label">WhatsApp</label>
          </div>
          
          <div class="form-group full-width">
            <input
              class="form-input"
              v-model="property.email"
              placeholder=" "
            />
            <label class="form-label">Email</label>
          </div>
        </div>
      </div>

      <div class="action-buttons-fixed">
        <button class="btn-secondary" @click="clearCustomerPropertyInputs">
          Novo
        </button>
        <button class="btn-primary" @click="saveOrUpdateProperty">
          {{ property.id ? "Atualizar" : "+ Adicionar" }}
        </button>
      </div>

      <PropertyMap
        ref="propertyMap"
        class="mb-3"
        :active="selectedLabel === 'Propriedades'"
        :latitude="property.latitude"
        :longitude="property.longitude"
        :marker-coordinates="propertyMarkerCoords"
        @location-selected="applyGeocodedLocation"
      />

      <TalhaoMap
        class="mb-3"
        :active="selectedLabel === 'Propriedades'"
        :latitude="talhao.latitude"
        :longitude="talhao.longitudade"
        :property-latitude="property.latitude"
        :property-longitude="property.longitude"
        @location-selected="applyTalhaoLocation"
      />

      <div v-if="customerProperties.length" class="compact-section">
        <div class="section-header">
          <b-icon-list class="section-icon"/>
          <span>Propriedades ({{ customerProperties.length }})</span>
        </div>
        <div class="property-list">
          <div
            v-for="property in customerProperties"
            :key="property.id"
            class="property-card"
            @click="findProperty(property.id)"
          >
            <div class="property-header">
              <h4 class="property-name">{{ property.nome }}</h4>
              <button
                class="delete-btn"
                @click.stop="getPropertyIdToDelete(property.id)"
              >
                <b-icon-trash-fill/>
              </button>
            </div>
            <div class="property-info">
              <div class="info-item">
                <span class="info-label">CPF/CNPJ:</span>
                <span>{{ property.cpfCnpj }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Endereço:</span>
                <span>{{ property.endereco || "--" }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Cidade:</span>
                <span>{{ property.cidade || "--" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="property.id" class="compact-section">
        <div class="section-header">
          <b-icon-grid3x3-gap-fill class="section-icon"/>
          <span>Talhões de {{ property.nome }}</span>
        </div>
        <div class="form-grid">
          <div class="form-group full-width">
            <input
              :class="`form-input ${invalidFieldsTalhao?.nome && 'error'}`"
              v-model="talhao.nome"
              @blur="clearInvalidFields('nome', 'invalidFieldsTalhao')"
              @input="clearInvalidFields('nome', 'invalidFieldsTalhao')"
              placeholder=" "
            />
            <label class="form-label">Nome do Talhão <span class="required">*</span></label>
          </div>
          <div class="form-group">
            <input class="form-input" v-model="talhao.cultura" placeholder=" " />
            <label class="form-label">Cultura</label>
          </div>
          <div class="form-group">
            <input class="form-input" v-model="talhao.latitude" placeholder=" " />
            <label class="form-label">Latitude</label>
          </div>
          <div class="form-group">
            <input class="form-input" v-model="talhao.longitudade" placeholder=" " />
            <label class="form-label">Longitude</label>
          </div>
          <div class="form-group full-width">
            <textarea class="form-input form-textarea" v-model="talhao.observacao" placeholder=" "></textarea>
            <label class="form-label">Observação</label>
          </div>
        </div>
        <div class="talhao-actions">
          <button class="btn-secondary" @click="clearTalhaoInputs">Novo</button>
          <button class="btn-primary" @click="saveOrUpdateTalhao">
            {{ talhao.id ? "Atualizar" : "+ Adicionar" }}
          </button>
        </div>

        <div v-if="talhoes.length" class="property-list">
          <div v-for="item in talhoes" :key="item.id" class="property-card" @click="findTalhao(item.id)">
            <div class="property-header">
              <h4 class="property-name">{{ item.nome }}</h4>
              <button class="delete-btn" @click.stop="getTalhaoIdToDelete(item.id)">
                <b-icon-trash-fill/>
              </button>
            </div>
            <div class="property-info">
              <div class="info-item"><span class="info-label">Cultura:</span><span>{{ item.cultura || "--" }}</span></div>
              <div class="info-item"><span class="info-label">Latitude:</span><span>{{ item.latitude || "--" }}</span></div>
              <div class="info-item"><span class="info-label">Longitude:</span><span>{{ item.longitudade || "--" }}</span></div>
            </div>
          </div>
        </div>
        <small v-else class="text-muted">Nenhum talhão cadastrado para esta propriedade.</small>
      </div>
    </div>

    <ModalConfirm
      modalName="confirmDeleteProperty"
      title="Excluir item"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar?"
      :rightButtonClick="deleteProperty"
    />

    <ModalConfirm
      modalName="confirmDeleteTalhao"
      title="Excluir talhão"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar?"
      :rightButtonClick="deleteTalhao"
    />

    <ModalConfirm
      typeModal="info"
      modalName="verifyProperty"
      title="Propriedade não vinculada!"
      subtitle="Este cliente não possui propriedade cadastrada. Deseja criar uma nova utilizando o endereço informado?"
      headerIcon="b-icon-patch-exclamation-fill"
      rightButtonText="Não"
      leftButtonText="Sim, utilizar!"
      :leftButtonClick="assingCustomerAddressToProperties"
    />
  </div>
</template>

<script>
import mixinCustomer from "../../mixins/Customer/Customer";

export default {
  props: {
    onClose: {
      type: Function,
      default: null,
    },
  },
  mixins: [mixinCustomer],
};
</script>
<style scoped>
.mobile-container {
  padding: 8px;
  max-width: 100vw;
  overflow-x: hidden;
  padding-bottom: 90px;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  margin-bottom: 12px;
  border-bottom: 2px solid #e8f5e8;
}

.mobile-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  justify-content: space-between;
}

.mobile-column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #2d5016;
  margin: 0;
}

.title-icon {
  color: #4caf50;
}

.btn-close-modern {
  background: #f0f0f0;
  border: none;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.btn-close-modern:hover {
  background: #ff4d4d;
  color: white;
}

.required-hint {
  font-size: 10px;
  color: #f44336;
  font-weight: 500;
}

.mobile-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  overflow-x: auto;
  padding: 5px;
}

.mobile-tabs::-webkit-scrollbar {
  height: 3px;
}

.mobile-tabs::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 2px;
}

.mobile-tab {
  flex: 0 0 auto;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #e8f5e8, #f1f8e9);
  color: #2d5016;
  white-space: nowrap;
  transition: all 0.2s ease;
  min-width: 80px;
}

.mobile-tab:hover {
  background: linear-gradient(135deg, #c8e6c9, #dcedc8);
  transform: translateY(-1px);
}

.mobile-tab.active {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.mobile-tab.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.compact-section {
  background: linear-gradient(135deg, #fafafa, #f5f5f5);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8e8e8;
}

.section-icon {
  color: #4caf50;
  font-size: 16px;
}

.section-header span {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.form-group {
  position: relative;
  min-height: 35px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group.two-thirds {
  grid-column: span 1;
  flex: 2;
}

.form-group.one-third {
  grid-column: span 1;
  flex: 1;
}

.form-input, .form-select, .form-textarea {
  width: 100%;
  height: 35px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  transition: all 0.2s ease;
  outline: none;
}

.form-input:focus, .form-select:focus, .form-textarea:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);
  transform: translateY(-1px);
}

.form-input.error, .form-select.error {
  border-color: #f44336;
  box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.1);
}

.form-textarea {
  height: 60px;
  resize: vertical;
  min-height: 35px;
}

.form-label, .select-label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #666;
  background: white;
  padding: 0 4px;
  pointer-events: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  z-index: 1;
}

.form-input:focus + .form-label,
.form-input:not(:placeholder-shown) + .form-label,
.form-select:focus + .select-label,
.form-select:not([value=""]) + .select-label {
  top: 0;
  transform: translateY(-50%) scale(0.85);
  color: #4caf50;
  font-weight: 600;
}

.required {
  color: #f44336;
  font-weight: 700;
}

.action-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
}

.action-btn:hover {
  background: linear-gradient(135deg, #43a047, #5cb85c);
  transform: translateY(-50%) scale(1.05);
}

.whatsapp-icon {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  background: #25d366;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.whatsapp-img {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.action-buttons-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 12px;
  display: flex;
  gap: 12px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 200;
}

.talhao-actions {
  display: flex;
  gap: 12px;
  margin: 12px 0;
}

.btn-primary, .btn-secondary {
  flex: 1;
  height: 44px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 6px;
}

.btn-primary {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #43a047, #5cb85c);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #f5f5f5, #e0e0e0);
  color: #333;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #eeeeee, #d5d5d5);
  transform: translateY(-1px);
}

.property-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.property-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 4px solid #4caf50;
}

.property-card:hover {
  border-color: #4caf50;
  box-shadow: 0 2px 12px rgba(76, 175, 80, 0.15);
  transform: translateY(-1px);
}

.property-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.property-name {
  font-size: 14px;
  font-weight: 700;
  color: #2d5016;
  margin: 0;
  text-transform: uppercase;
}

.delete-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #f44336, #e57373);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background: linear-gradient(135deg, #d32f2f, #f44336);
  transform: scale(1.05);
}

.property-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item {
  display: flex;
  font-size: 12px;
}

.info-label {
  font-weight: 600;
  color: #666;
  min-width: 60px;
}

.select-group .form-select {
  padding-right: 30px;
}

@media (max-width: 480px) {
  .mobile-container {
    padding: 4px;
    padding-bottom: 90px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  
  .form-group.two-thirds,
  .form-group.one-third {
    grid-column: 1;
  }
  
  .mobile-header {
    align-items: flex-start;
    gap: 4px;
  }
  
  .action-buttons-fixed {
    flex-direction: column;
  }
  
  .property-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .delete-btn {
    align-self: flex-end;
  }
}

@media (min-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
  
  .mobile-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 16px;
    padding-bottom: 110px;
  }

  .action-buttons-fixed {
    max-width: 800px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.text-center { text-align: center; }
.text-right { text-align: right; }
.mb-0 { margin-bottom: 0; }
.mt-0 { margin-top: 0; }

.form-input:disabled,
.form-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

*:focus {
  outline: none;
}

.form-input:focus,
.form-select:focus,
.mobile-tab:focus,
.btn-primary:focus,
.btn-secondary:focus {
  outline: 2px solid #4caf50;
  outline-offset: 2px;
}
</style>
